<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import PrizePoolTable from "./parts/prize-pool-table.svelte";
export let maxLength = undefined;
export let raceId = "current";
export let useBetFeedStyles = false;
</script>

{#if useBetFeedStyles}
	<PrizePoolTable {maxLength} {raceId} {useBetFeedStyles} />
{:else}
	<InfoCard width="100%">
		<Text
			type="subtitle"
			subtitleSize="large"
			subtitleWeight="bold"
			customStyle="margin-bottom: 1rem;"
		>
			{$t(Verbiage.race_leaderboard)}</Text
		>
		<PrizePoolTable {maxLength} {raceId} {useBetFeedStyles} />
	</InfoCard>
{/if}
